import _ from 'lodash';
import BaseCtrl from 'edge/platform/base/BaseCtrl';
import 'text!../views/create-message.html';

const fn = ($filter, $scope, $state, $q, $stateParams, ModalService, ServiceRequestService, ViewModelService) => {
    const ctrl = Object.create(BaseCtrl);

    ctrl.init = () => {
        $scope.message = ViewModelService.create({
            'title': '',
            'body': '',
            'type': 'question'
        }, 'cc', 'edge.capabilities.servicerequest.message.dto.ServiceRequestMessageDTO');

        $scope.messageTypes = {
            info: _.find($scope.message.type.aspects.availableValues, {
                code: 'info'
            }),
            question: _.find($scope.message.type.aspects.availableValues, {
                code: 'question'
            })
        };
        
    };

    ctrl.createMessage = (serviceRequestMessageForm) => {
        serviceRequestMessageForm.submitted = true;
        $scope.message.sendDate.value = new Date(); // To maintain up-to-the-minute info
        if ($scope.message.aspects.subtreeValid) {
            $scope.submitMessagePromise = ServiceRequestService.createMessage($stateParams.serviceRequestNumber, $scope.message.value).then(
                () => {
                    $state.transitionTo($state.$current.data.actions.serviceRequestDetails, {serviceRequestNumber: $stateParams.serviceRequestNumber});
                },
                () => {
                    ModalService.showError(
                        'servicerequest.controllers.CreateMessageCtrl.Service Request update failed',
                        'servicerequest.controllers.CreateMessageCtrl.Sorry, we were not able to add a new message to your service request.'
                    );
                }
            );
        }
    };

    ctrl.goToPreviousState = () => {
        $state.transitionTo($state.$current.data.actions.serviceRequestDetails, {
            serviceRequestNumber: $stateParams.serviceRequestNumber
        });
    };

    return ctrl.create($scope);
};

fn.$inject = ['$filter', '$scope', '$state', '$q', '$stateParams', 'ModalService', 'servicerequest.ServiceRequestService', 'ViewModelService'];
export default fn;
